import { render, staticRenderFns } from "./Prescriptor.vue?vue&type=template&id=c6b7af2e&scoped=true"
import script from "./Prescriptor.vue?vue&type=script&lang=js"
export * from "./Prescriptor.vue?vue&type=script&lang=js"
import style0 from "./Prescriptor.vue?vue&type=style&index=0&id=c6b7af2e&prod&lang=scss&scoped=true"
import style1 from "./Prescriptor.vue?vue&type=style&index=1&id=c6b7af2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b7af2e",
  null
  
)

export default component.exports